import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIResponse } from '@/types/generate-ai';
import type { PositioningAIGenerateFormData } from './positioning-ai-generate.schema';

interface UseGeneratePositioningOptions {
  tenantId: string;
}

export const useGeneratePositioning = ({ tenantId }: UseGeneratePositioningOptions) => {
  return useMutation<GenerateAIResponse, Error, PositioningAIGenerateFormData>({
    mutationFn: async (data: PositioningAIGenerateFormData) => {
      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-positioning`,
          data,
        );
        return response.data;
      } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to generate positioning';
        throw new Error(message);
      }
    },
  });
};
